import {
    ClientApi,
    Configuration,
    CreditNoteApi,
    DocumentApi,
    E2EApi,
    HealthApi,
    LocationApi,
    OrderApi,
    PartnerApi,
    UserApi,
} from '@/generated';
import { apiAxios } from '@/plugins/axios';
import { type Env, getEnv } from '@/utils/envUtils';

const env: Env = getEnv();
const config = new Configuration({
    basePath: env?.VITE_API_BASE || '',
});

export const healthApi: HealthApi = new HealthApi(config, undefined, apiAxios);
export const clientApi: ClientApi = new ClientApi(config, undefined, apiAxios);
export const locationApi: LocationApi = new LocationApi(config, undefined, apiAxios);
export const orderApi: OrderApi = new OrderApi(config, undefined, apiAxios);
export const e2eApi: E2EApi = new E2EApi(config, undefined, apiAxios);
export const creditNoteApi: CreditNoteApi = new CreditNoteApi(config, undefined, apiAxios);
export const documentApi: DocumentApi = new DocumentApi(config, undefined, apiAxios);
export const partnerApi: PartnerApi = new PartnerApi(config, undefined, apiAxios);
export const userApi: UserApi = new UserApi(config, undefined, apiAxios);
